var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":""}},[_c('h1',[_vm._v("photos")]),_vm._l((_vm.photos),function(photo){return _c('div',{key:photo.file,staticClass:"photo"},[_c('img',{attrs:{"src":'https://s3.amazonaws.com/road-trip-blog/' +
          photo.file.split('.')[0] +
          '-w700.webp',"alt":""},on:{"click":function($event){return _vm.copyDate(photo)}}})])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }